var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.customClass')
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "default-first-option": ""
    },
    model: {
      value: (_vm.optionModel.customClass),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "customClass", $$v)
      },
      expression: "optionModel.customClass"
    }
  }, _vm._l((_vm.cssClassList), function(item, idx) {
    return _c('el-option', {
      key: idx,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.tabPaneSetting')
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "panes-setting",
    attrs: {
      "label-width": "0"
    }
  }, [_c('draggable', _vm._b({
    attrs: {
      "tag": "ul",
      "list": _vm.selectedWidget.tabs
    }
  }, 'draggable', {
    group: 'panesGroup',
    ghostClass: 'ghost',
    handle: '.drag-option'
  }, false), [_vm._l((_vm.selectedWidget.tabs), function(tpItem, tpIdx) {
    return _c('li', {
      key: tpIdx,
      staticClass: "col-item"
    }, [_c('el-checkbox', {
      staticStyle: {
        "margin-right": "8px"
      },
      attrs: {
        "disabled": ""
      },
      on: {
        "change": function (evt) { return _vm.onTabPaneActiveChange(evt, tpItem); }
      },
      model: {
        value: (tpItem.options.active),
        callback: function($$v) {
          _vm.$set(tpItem.options, "active", $$v)
        },
        expression: "tpItem.options.active"
      }
    }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.paneActive')))]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "155px"
      },
      attrs: {
        "type": "text"
      },
      model: {
        value: (tpItem.options.label),
        callback: function($$v) {
          _vm.$set(tpItem.options, "label", $$v)
        },
        expression: "tpItem.options.label"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-drag drag-option"
    }), _vm._v(" "), _c('el-button', {
      staticClass: "col-delete-button",
      attrs: {
        "circle": "",
        "plain": "",
        "size": "mini",
        "type": "danger",
        "icon": "el-icon-minus"
      },
      on: {
        "click": function($event) {
          return _vm.deleteTabPane(_vm.selectedWidget, tpIdx)
        }
      }
    })], 1)
  }), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.addTabPane(_vm.selectedWidget)
      }
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.addTabPane')))])], 1)], 2)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3417db6a","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/container-tab/tab-customClass-editor.vue
// module id = null
// module chunks = 